__turbopack_context__.v({
  "backdrop": "QuickAddPopover-module-scss-module__uOVkxa__backdrop",
  "backdropHidden": "QuickAddPopover-module-scss-module__uOVkxa__backdropHidden",
  "closeButton": "QuickAddPopover-module-scss-module__uOVkxa__closeButton",
  "errorMessage": "QuickAddPopover-module-scss-module__uOVkxa__errorMessage",
  "fallback": "QuickAddPopover-module-scss-module__uOVkxa__fallback",
  "header": "QuickAddPopover-module-scss-module__uOVkxa__header",
  "headerDesktop": "QuickAddPopover-module-scss-module__uOVkxa__headerDesktop",
  "headerSheet": "QuickAddPopover-module-scss-module__uOVkxa__headerSheet",
  "popup": "QuickAddPopover-module-scss-module__uOVkxa__popup",
  "popupDesktop": "QuickAddPopover-module-scss-module__uOVkxa__popupDesktop",
  "popupSheet": "QuickAddPopover-module-scss-module__uOVkxa__popupSheet",
  "popupSheetSuccess": "QuickAddPopover-module-scss-module__uOVkxa__popupSheetSuccess",
  "positioner": "QuickAddPopover-module-scss-module__uOVkxa__positioner",
  "positionerDesktop": "QuickAddPopover-module-scss-module__uOVkxa__positionerDesktop",
  "positionerSheet": "QuickAddPopover-module-scss-module__uOVkxa__positionerSheet",
  "positionerSheetSuccess": "QuickAddPopover-module-scss-module__uOVkxa__positionerSheetSuccess",
  "quickAddPulse": "QuickAddPopover-module-scss-module__uOVkxa__quickAddPulse",
  "sizeGrid": "QuickAddPopover-module-scss-module__uOVkxa__sizeGrid",
  "sizeGridDesktop": "QuickAddPopover-module-scss-module__uOVkxa__sizeGridDesktop",
  "sizeGridSheet": "QuickAddPopover-module-scss-module__uOVkxa__sizeGridSheet",
  "skeletonCell": "QuickAddPopover-module-scss-module__uOVkxa__skeletonCell",
  "spinnerWrapper": "QuickAddPopover-module-scss-module__uOVkxa__spinnerWrapper",
  "success": "QuickAddPopover-module-scss-module__uOVkxa__success",
  "successIcon": "QuickAddPopover-module-scss-module__uOVkxa__successIcon",
  "successLabel": "QuickAddPopover-module-scss-module__uOVkxa__successLabel",
  "surface": "QuickAddPopover-module-scss-module__uOVkxa__surface",
  "surfaceDesktop": "QuickAddPopover-module-scss-module__uOVkxa__surfaceDesktop",
  "surfacePanel": "QuickAddPopover-module-scss-module__uOVkxa__surfacePanel",
  "surfaceSheet": "QuickAddPopover-module-scss-module__uOVkxa__surfaceSheet",
  "surfaceSuccess": "QuickAddPopover-module-scss-module__uOVkxa__surfaceSuccess",
  "titleDesktop": "QuickAddPopover-module-scss-module__uOVkxa__titleDesktop",
  "titleHidden": "QuickAddPopover-module-scss-module__uOVkxa__titleHidden",
  "titleSheet": "QuickAddPopover-module-scss-module__uOVkxa__titleSheet",
  "viewProductLink": "QuickAddPopover-module-scss-module__uOVkxa__viewProductLink",
});
